import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import useCanCreatePluginTemplates from "shared/Plugins/access/useCanCreatePluginTemplates";
import useCanDeletePluginTemplates from "shared/Plugins/access/useCanDeletePluginTemplates";
import useCanInstallPlugins from "shared/Plugins/access/useCanInstallPlugins";
import { PluginTemplate } from "types/generated";

import { showDeleteConfirmation } from "../DeleteConfirmation";
import { showInstallPluginDrawer } from "../InstallPluginDrawer";
import { showPluginTemplateCreateDrawer } from "../PluginTemplateCreateDrawer";
import { showPluginTemplateDetailsDrawer } from "../PluginTemplateDetailsDrawer";
import { PluginTemplatesTableContext } from "../PluginTemplatesTableContext";

const PluginTemplatesTableActionsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PluginTemplate>) => {
  const { takenPluginNames } = useTypedContext(PluginTemplatesTableContext);
  const canInstallPlugins = useCanInstallPlugins();
  const canCreatePluginTemplates = useCanCreatePluginTemplates();
  const canDeleteTemplate = useCanDeletePluginTemplates()(template);

  const handleCreatePlugin = () => {
    showPluginTemplateCreateDrawer({
      takenPluginNames: takenPluginNames,
      defaultValues: {
        name: template.name,
        description: template.description || "",
        manifest: template.manifest,
        labels: template.labels || [],
      },
    });
  };

  const openDetails = () => {
    showPluginTemplateDetailsDrawer({
      templateName: template.name,
      manifest: template.manifest || "",
    });
  };

  const handleInstall = () => {
    showInstallPluginDrawer({
      title: `Install plugin: ${template.name}`,
      parameters: template.parameters ?? [],
      name: template.name,
      labels: template.labels || [],
      templateId: template.id,
    });
  };

  const handleDelete = () => {
    showDeleteConfirmation({
      name: template.name,
      id: template.id,
    });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Plugin actions">
        <DropdownMenuItem
          onAction={handleInstall}
          isDisabled={!canInstallPlugins.result}
          tooltip={canInstallPlugins.message}
        >
          Install
        </DropdownMenuItem>
        <DropdownMenuItem onAction={openDetails}>See manifest</DropdownMenuItem>
        <DropdownMenuItem
          onAction={handleCreatePlugin}
          isDisabled={!canCreatePluginTemplates.result}
          tooltip={canCreatePluginTemplates.message}
        >
          New template from this
        </DropdownMenuItem>
        <DropdownMenuItem
          onAction={handleDelete}
          isDisabled={!canDeleteTemplate.result}
          tooltip={canDeleteTemplate.message}
          danger
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default PluginTemplatesTableActionsCell;
